import { render, staticRenderFns } from "./UserLoadsPopup.vue?vue&type=template&id=2e319280&scoped=true"
import script from "./UserLoadsPopup.vue?vue&type=script&lang=js"
export * from "./UserLoadsPopup.vue?vue&type=script&lang=js"
import style0 from "./UserLoadsPopup.vue?vue&type=style&index=0&id=2e319280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e319280",
  null
  
)

export default component.exports